export default __webpack_public_path__ + "static/media/sip_biz.8e55df18.png";